import { Component, Input } from '@angular/core';
import { GameSettingsService } from '../../game-settings.service';

@Component({
  selector: 'color-confetti',
  templateUrl: './color-confetti.component.html',
  styleUrls: ['./color-confetti.component.scss']
})
export class ColorConfettiComponent { 

  @Input('index') index: number = 0;

  constructor(public gameSettingsService: GameSettingsService) { }

}
